import type { FC, MouseEvent, ReactNode } from "react";
import { Btn } from "@/shared/ui/btn";
import chromeIcon from "/assets/images/chrome.svg";
import type { IButtonProps } from "@/shared/ui/btn/config";

/**
 * Фича скачивания расширения
 * @returns {ReactNode}
 */
export const InstallOnChrome: FC<{ typeStyle?: IButtonProps["typeStyle"]; }> = ({
  typeStyle = "secondary",
}): ReactNode => {

  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    (window as any).open("https://chromewebstore.google.com/detail/deepsum-youtube-ai-summar/cpojeidlghjghloilgkgdeoielaebfmo", "_blank").focus();
  };

  return (
    <Btn onClick={onClick} className={"gap-3 min-w-60"} typeStyle={typeStyle}>
      <img draggable={false} src={chromeIcon} alt={"Install on Chrome"} width={32} height={32} />
      Install on Chrome
    </Btn>
  );

};
